import type {
  EligiblePackageFilter,
  EligibleTriggerFilter,
} from "../../domain/services/filter-eligible-package-notifications";

export type EligibleNotificationsFilters = {
  search: string;
  packageType: EligiblePackageFilter;
  triggerType: EligibleTriggerFilter;
};

export {
  countEligibleByPackageType,
  countEligibleByTriggerType,
  filterEligiblePackageNotifications as filterEligibleNotifications,
} from "../../domain/services/filter-eligible-package-notifications";

export type { EligibleStats } from "../../domain/contracts/http";

export const DEFAULT_ELIGIBLE_NOTIFICATIONS_FILTERS: EligibleNotificationsFilters =
  {
    search: "",
    packageType: "all",
    triggerType: "all",
  };

export type {
  EligiblePackageFilter as EligibleNotificationsPackageFilter,
  EligibleTriggerFilter as EligibleNotificationsTriggerFilter,
} from "../../domain/services/filter-eligible-package-notifications";
